import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { omit } from 'lodash-es'

import Layout from 'antd/lib/layout'
import 'antd/lib/layout/style/css'

import './LayoutComponent.scss'

const LayoutComponent = (props) => {
  const { niceSidebar } = props

  return (
    <div
      className={classnames('layout-component antd-component', {
        'nice-sidebar': niceSidebar,
      })}
    >
      <Layout {...omit(props, 'niceSidebar')} />
    </div>
  )
}

LayoutComponent.propTypes = {
  niceSidebar: PropTypes.bool,
}

LayoutComponent.deafultProps = {
  niceSidebar: false,
}

LayoutComponent.Sider = Layout.Sider
LayoutComponent.Content = Layout.Content
LayoutComponent.Footer = Layout.Footer

export default LayoutComponent
